<template>
    <div class="ui-control" :class="{ 'ui-control--block': block }">
        <button
            :type="type"
            class="ui-control__shell ui-control__shell--button"
            :class="[
                variant === 'primary'
                    ? 'ui-control__shell--button-primary'
                    : 'ui-control__shell--button-secondary',
                { 'is-disabled': disabled },
            ]"
            :disabled="disabled"
            @click="$emit('click', $event)"
        >
            <slot />
        </button>
    </div>
</template>

<script setup>
defineProps({
    variant: {
        type: String,
        default: 'secondary',
        validator: (value) => ['primary', 'secondary'].includes(value),
    },
    disabled: { type: Boolean, default: false },
    type: { type: String, default: 'button' },
    block: { type: Boolean, default: false },
});

defineEmits(['click']);
</script>
